<template>
  <div id="app">
    <Header v-if="!nonHeaderRoutes.includes($route.name)"/>
    <router-view />
    <Footer v-if="!nonFooterRoutes.includes($route.name)"/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      nonHeaderRoutes: ['alumni', 'xtian', 'xygan'],
      nonFooterRoutes: ['alumni', 'xtian', 'xygan']
    }
  }
}
</script>
<style lang="less">
@import './reset.css';
#app {
  font-family: Source Han Sans SC, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .main-container {
    width: 1500px;
    margin: auto;
    min-height: calc(100vh - 457px);
  }
  .header-list, .header-main-containner {
     width: 1500px;
  }
  /* 针对最大宽度为980像素的设备 */
    @media screen and (max-width: 2400px) {
        .main-container, .header-list, .header-main-containner {
            width: 1300px;
        }
    }
    /* 针对最大宽度为980像素的设备 */
    @media screen and (max-width: 1440px) {
        .main-container, .header-list, .header-main-containner {
            width: 1000px;
        }
    }
  /* 针对最大宽度为1100像素的设备 */
    @media screen and (max-width: 1100px) {
        .main-container, .header-list, .header-main-containner {
            width: 740px;
        }
    }
    /* 针对最大宽度为768像素的设备 */
    @media screen and (max-width: 768px) {
        .main-container, .header-list, .header-main-containner {
            width: 550px;
        }
    }
    /* 针对最大宽度为580像素的设备 */
    @media screen and (max-width: 580px) {
        .main-container, .header-list, .header-main-containner {
            width: 430px;
        }
    }
    
    /* 针对最大宽度为480像素的设备 */
    @media screen and (max-width: 480px) {
        .main-container, .header-list, .header-main-containner {
            width: 300px;
        }
    }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
